"use client";

import { MapSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import MapSectionGenerated from "../Sections/_generated/MapSection.generated";

const GeneratedMapSection: FC<MapSectionProps> = (props) => {
  const location = props.pageData.CommonData.Location?.trim();

  if (!location) {
    return <></>;
  }

  return <MapSectionGenerated divIframe0IframeSrc={location} />;
};

export default GeneratedMapSection;
